const CHUNK_RELOAD_KEY = "chunkErrorReloadAt";
const CHUNK_RELOAD_LOOP_WINDOW_MS = 10_000;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const err = error as { name?: string; message?: string };
  if (err.name === "ChunkLoadError") return true;
  const msg = err.message || "";
  return (
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk [\w-]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

export function hasRecentReloadAttempt(): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    return Date.now() - last < CHUNK_RELOAD_LOOP_WINDOW_MS;
  } catch {
    return false;
  }
}

export function markReloadAttempt(): void {
  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage may be unavailable; reload anyway
  }
}

export function reloadIfStaleChunkError(
  error: unknown,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (!isChunkLoadError(error)) return false;
  if (hasRecentReloadAttempt()) return false;
  markReloadAttempt();
  reload();
  return true;
}
